import callApi from '../index';
import CONFIG_API from '../EndpointConfig';

const getAllStatusByType = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllStatusByType`,
  'post',
  params,
  true,
);

const getCacheTerminal = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getCacheTerminal`,
  'post',
  params,
);

const getAllBank = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllBank`,
  'get',
  params,
);

const getAllMccInternational = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllMccInternational`,
  'get',
  params,
);

const getAllMccInterior = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllMccInterior`,
  'get',
  params,
);

const getAllProvince = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllProvince`,
  'get',
  params,
);

const getAllBranchBank = (params) => callApi(
  `${CONFIG_API.MERCHANTVIEW_API_BE}mc/system/getAllBranchBank`,
  'get',
  params,
);

export {
  getAllStatusByType,
  getCacheTerminal,
  getAllBank,
  getAllMccInternational,
  getAllMccInterior,
  getAllProvince,
  getAllBranchBank,
};
